import React from "react";
import { MainContainer } from "../Components/Elements";
import PagesNav from "../Components/PagesNav";
import SearchInput from "../Components/SearchInput";
import AddInput from "../Components/AddInput";
import { Accordion } from "react-bootstrap";
import PermissionGroupHooks from "../hooks/MangmentHooks/PermissionGroupHooks";
import editBtn from "../assets/icons/PermissionEdit.png";
import deleteBtn from "../assets/icons/PermissionDelete.png";
import { Link } from "react-router-dom";
import Shimmer from "../Components/Shimmer";
import Pagination from "../Components/Pagination";

const PermissionGroup = () => {
  const {
    NavItems,
    setSearch,
    handleShow,
    show,
    handleClose,
    loading,
    permissionGroup,
    handleNextPage,
    handlePrevPage,
    totalPages,
    currentPage,
    formatLabel,
    formatDate,
    onSubmitdelete,
  } = PermissionGroupHooks();

  return (
    <>
      <MainContainer>
        <div className="d-flex gap-3 mb-3 align-items-center">
          <PagesNav links={NavItems} />
          <div className="d-flex gap-2">
            <SearchInput search={(e) => setSearch(e.target.value)} />
            <Link to={"/management/permissiongroup/addpermissiongroup"}>
              <AddInput />
            </Link>
          </div>
        </div>
        {loading && <Shimmer type={""} colSpan={5} />}

        <Accordion>
          {permissionGroup?.map((permission, index) => (
            <Accordion.Item eventKey={index.toString()} key={permission._id}>
              <Accordion.Header>{permission.name}</Accordion.Header>
              <Accordion.Body>
                <section className="row gy-3">
                  {Object.keys(permission).map((key) => {
                    if (
                      typeof permission[key] === "boolean" &&
                      permission[key] === true &&
                      key !== "_id" &&
                      key !== "name" &&
                      key !== "createdAt" &&
                      key !== "updatedAt"
                    ) {
                      return (
                        <div className="col-md-3" key={key}>
                          <label>{formatLabel(key)}</label>
                        </div>
                      );
                    }
                    return null;
                  })}

                  <div className="text-end">
                    <Link
                      to="/management/permissiongroup/addpermissiongroup"
                      state={{ permission }}
                    >
                      {" "}
                      <img src={editBtn} alt="editBtn" />
                    </Link>
                    <button
                      className="btn bg-white text-main "
                      onClick={() => onSubmitdelete(permission._id)}
                    >
                      <img src={deleteBtn} alt="deleteBtn" />
                    </button>
                  </div>
                </section>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
        <Pagination
          handleNextPage={handleNextPage}
          handlePrevPage={handlePrevPage}
          totalPages={totalPages}
          currentPage={currentPage}
        />
      </MainContainer>
    </>
  );
};

export default PermissionGroup;
